import { useState } from "react";
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import "./index.css";
import CommonLayout from "../../_utils/CommonLayout";

const ScheduleInternalTxnAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  isNeft,
  setIsNeft,
  isRtgs,
  setIsRtgs,
  setIsImps,
  setNextButtonEnabled,
  setShowRupeeSymbol,
  amountInWords,
  setAmountInWords,
}) => {
  const [slideAnimation, setSlideAnimation] = useState(false);

  const allowedValue = (value) => Validation.allowedAmount(value);

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      setShowRupeeSymbol(false);
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const rawWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedWords =
        amountNumber > 0 && amountNumber <= 1
          ? rawWords.replace("rupees", "rupee")
          : rawWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedWords,
      }));

      setShowRupeeSymbol(numericValue.trim() !== "");
      setAmountInWords(adjustedWords);
    }
  };

  return (
    <div
      className="w-width-full h-height-full items-start px-padding-md lg:px-padding-base pb-padding-md pt-padding-lg"
      style={{ scrollbarWidth: "none" }}
    >
      <CommonLayout>
        <Amount
          title={TEXT.TRANSFER_AMOUNT}
          amount={txnPayLoad?.amount}
          amountInWords={amountInWords}
          copyData={null}
          onAmountChange={(val) =>
            handleAmountChange({ name: "amount", value: val })
          }
          onPasteApplied={() => {}}
          isPreview={false}
          txnPayLoad={txnPayLoad}
        />

        <PaymentMethodSelector
          title={TEXT.SELECT_PAYMENT_METHOD}
          slideAnimation={slideAnimation}
          previewMode={false}
          methods={[
            {
              key: "neft",
              label: TEXT.NEFT,
              subText: TEXT.NEFT_TRANSFER_NOTE,
              active: isNeft,
              notes: [
                TEXT.TRANSACTION_EXECUTION_NOTE,
                TEXT.TRANSACTION_LIMIT_NOTE,
                TEXT.TRANSACTION_CHARGES_NOTE,
              ],

              onClick: () => {
                if (!isNeft) setSlideAnimation(true);
                setTimeout(() => setSlideAnimation(false), 120);

                setIsNeft(true);
                setIsImps(false);
                setIsRtgs(false);

                setTxnPayLoad((prev) => ({
                  ...prev,
                  settleType: "neft",
                }));
                setNextButtonEnabled(false);
              },
            },

            {
              key: "rtgs",
              label: TEXT.RTGS,
              subText: TEXT.INSTANT_TRANSFER_NOTE,
              active: isRtgs,
              notes: [
                TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                TEXT.TRANSACTION_CHARGES_NOTE,
              ],

              onClick: () => {
                if (!isRtgs) setSlideAnimation(true);
                setTimeout(() => setSlideAnimation(false), 120);

                setIsNeft(false);
                setIsImps(false);
                setIsRtgs(true);

                setTxnPayLoad((prev) => ({
                  ...prev,
                  settleType: "rtgs",
                }));
              },
            },
          ]}
        />
      </CommonLayout>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default ScheduleInternalTxnAmount;
